const sortByKeys = Object.freeze({
    DEFAULT_KEY: 'sortByPreference',
    SPECIALS_KEY: 'sortByPreference_specials',
    SEARCH_RESULTS_KEY: 'sortByPreference_search',
    BROWSE_KEY: 'sortByPreference_browse',
    LISTS_KEY: 'sortByPreference_lists',
    PRODUCT_GROUPS_KEY: 'sortByPreference_productGroups',
    NEW_KEY: 'sortByPreference_new',
    RECIPE_KEY: 'sortByPreference_recipe',
    REVIEW_KEY: 'sortByPreference_review',
});

module.exports = {
    sortByKeys,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/tile-list-sort-by-keys.constants.js